import * as React from 'react';
import { Chip } from '@mui/material';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import GroupWorkIcon from '@mui/icons-material/GroupWork';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Localized } from '@fluent/react';

import { ProcessTeamMemberRole } from '../ProjectProcessApiClient';

type MuiColor = 'default' | 'primary' | 'secondary' | 'success' | 'info' | 'warning' | 'error';

type RoleMeta = {
    color: MuiColor;
    icon: React.ReactElement;
    l10nId: string;
    fallback: string;
};

const ROLE_META: Record<string, RoleMeta> = {
    // M = Manager
    M: { color: 'success', icon: <ManageAccountsIcon fontSize="small" />, l10nId: 'role-manager', fallback: 'MANAGER' },
    // C = Collaborator
    C: { color: 'secondary', icon: <GroupWorkIcon fontSize="small" />, l10nId: 'role-collaborator', fallback: 'COLLABORATOR' },
    // O = Observer
    O: { color: 'info', icon: <VisibilityIcon fontSize="small" />, l10nId: 'role-observer', fallback: 'OBSERVER' },
};

export interface ProcessTeamMemberRoleChipProps {
    role: ProcessTeamMemberRole | string;
    size?: 'small' | 'medium';
}

const ProcessTeamMemberRoleChip: React.FC<ProcessTeamMemberRoleChipProps> = ({
    role,
    size = 'small',
}) => {
    const meta = ROLE_META[role as string];

    return (
        <Chip
            size={size}
            variant="outlined"
            color={meta.color}
            icon={meta.icon}
            label={
                <Localized id={meta.l10nId}>
                    <span>{meta.fallback}</span>
                </Localized>
            }
        />
    );
};

export default ProcessTeamMemberRoleChip;
